import React from 'react';
// import PropTypes from 'prop-types';
import { connect } from 'dva';

import X from '../../../assets/svg/Feather/X';
import styles from './HistoricalRestrictionModal.module.scss';

function HistoricalRestrictionModal(props) {

  const closeModal = () => {
    props.dispatch({
      type: 'modals/close'
    });
  };

  return (
    <div className={styles.container}>
      <button className={styles.closeButton} onClick={closeModal}>
        <X width={14} color='#939393' />
      </button>
      <h1 className={styles.title}>Feature Not Supported</h1>
      <p className={styles.body}>Historical Imagery is only available while using 2D</p>
    </div>
  );
}

HistoricalRestrictionModal.propTypes = {
};

export default connect(() => ({}))(HistoricalRestrictionModal);